import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormArray } from '@angular/forms';
import { TalepService } from 'src/app/services/talep.service';
import { ToastrService } from 'ngx-toastr';
import {
  KayitTurModel,
  UserModel,
} from 'src/app/models/talepAdd2Model';
import { Observable } from 'rxjs';
import { TalepAdd3Model } from 'src/app/models/talepAdd3Model';
import { environment } from 'src/environments/environment';
import { HizmetServisTanimMarkaModel } from 'src/app/models/talepIsTuruModelDto';
@Component({
  selector: 'app-talepadd3',
  templateUrl: './talepadd3.component.html',
  styleUrls: ['./talepadd3.component.css'],
})
export class Talepadd3Component implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  dataLoaded = false;
  submitted = false;
  kayitTurModels: KayitTurModel[];
  markaList: HizmetServisTanimMarkaModel[];
  modelList: HizmetServisTanimMarkaModel[];
  Users: UserModel[];
  myFiles: string[] = [];
  model: TalepAdd3Model;
  markaselected: number;
    modelaselected: number;
  cihazEklenecek = true;
  isCihazZorunlu = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private talepService: TalepService
  ) { }

  ngOnInit() {
    this.isCihazZorunlu = environment.isCihazZorunlu;

    this.GetIsTurList();
    this.GetTanimList();

    this.form = this.formBuilder.group({
      cihazturid: ['', Validators.required],
      konu: ['', Validators.required],
      sikayet: ['', Validators.required],
      file: ['', null],
      musteriAdSoyad: ['', Validators.required],
      musteriCepTel: ['', [Validators.required]],
      musteriEmail: ['', Validators.required],
      musteriAdres: ['', Validators.required],
      cihazEklenecekMi: [this.cihazEklenecek],
      cihazlar: this.formBuilder.array([]),
    });

    if (this.isCihazZorunlu) {
      this.cihazEklenecek = true; // Cihaz alanı açık başlasın
      this.addCihaz();
    }

  }

  get f() {
    return this.form.controls;
  }

  get cihazlar() {
    return this.form.get('cihazlar') as FormArray;
  }

  addCihaz() {
    const cihazForm = this.formBuilder.group({
      marka: ['', null],      // Marka adı
      model: ['', null],      // Model adı
      markaid: ['', null],    // Marka ID (dropdown için)
      modelid: ['', null],    // Model ID (dropdown için)
      serino: ['', null],
      barkod: ['', null],
      manuelGiris: [false]
    });
    this.cihazlar.push(cihazForm);
  }

  removeCihaz(index: number) {
    this.cihazlar.removeAt(index);
  }

  toggleCihazEkleme() {
    this.cihazEklenecek = this.form.get('cihazEklenecekMi')?.value;
  }

  onFileChange(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
    }
  }

  changeCity(e: any) {
    this.Users = this.kayitTurModels.filter(
      (p) => p.Id == e.target.value
    )[0].Users;
  }


  changeMarka(event: any, index: number) {
    const selectedId = event.target.value;
    const selectedMarka = this.markaList.find(m => m.Id == selectedId);
    const cihaz = this.cihazlar.at(index);
    cihaz.patchValue({
      markaid: selectedId,
      marka: selectedMarka ? selectedMarka.Name : ''
    });
    this.GetModelList(selectedId);
  }

  changeModel(event: any, index: number) {
    const selectedId = event.target.value;
    const selectedModel = this.modelList.find(m => m.Id == selectedId);
    const cihaz = this.cihazlar.at(index);
    cihaz.patchValue({
      modelid: selectedId,
      model: selectedModel ? selectedModel.Name : ''
    });
  }

  GetIsTurList() {
    this.talepService.GetIsTurList().subscribe((a) => {
      this.kayitTurModels = a.Veri;
    });



  }

  GetTanimList() {

    this.talepService.GetTanimList().subscribe((a) => {
      this.markaList = a.Veri.MarkaList;
      
      this.dataLoaded = true;
    });

  }

  GetModelList(markaid: number) {
    this.dataLoaded = false;
    if(!markaid || markaid==0){
      this.modelList=[];
      this.dataLoaded = true;
      return;
    }
    this.talepService.GetModelList(markaid).subscribe((a) => {
      this.modelList = a.Veri;
       this.dataLoaded = true;
    });



    this.dataLoaded = true;
  }

  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';

  fileInfos?: Observable<any>;

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }
  onSubmit() {
    this.submitted = true;

    this.model = Object.assign({}, this.form.value);

    // stop here if form is invalid
    if (this.form.invalid) {
      const invalidFields = Object.keys(this.form.controls).filter(
        (field) => this.form.get(field)?.invalid
      );
      const invalidFieldNames = invalidFields.join(', ');
      this.toastrService.error(
        `Zorunlu alanları doldurun: ${invalidFieldNames}`,
        'Dikkat'
      );
      return;
    }

    if (this.isCihazZorunlu && this.cihazlar.length === 0) {
      this.toastrService.error('Cihaz bilgisi zorunludur.', 'Dikkat');
      return;


    }

    // Marka ve model kontrolü
    for (let i = 0; i < this.cihazlar.length; i++) {
      const cihaz = this.cihazlar.at(i).value;
      if (!cihaz.marka || !cihaz.model) {
        this.toastrService.error(`${i + 1}. Cihaz için marka ve model bilgisi zorunludur.`, 'Dikkat');
        return;
      }
    }
   
    this.loading = true;

    this.talepService.TalepAdd3Json(this.model, this.myFiles).subscribe(
      (res) => {
        if (res.BasariliMi) {
          this.toastrService.info('Giriş Başarılı', 'Başarılı!');
          this.router.navigateByUrl('/talep');
        } else {
          this.toastrService.error(res.Mesaj, 'Dikkat!1');
          this.loading = false;
        }
      },
      (err) => {
        this.toastrService.error(err.Mesaj, 'Dikkat!2');
        this.loading = false;
      }
    );
  }

  onCepTelInput(event: any) {
    let value = event.target.value.replace(/[^0-9]/g, ''); // Sadece rakamları al
    if (value.startsWith('0')) {
      value = value.substring(1);
    }
    this.form.get('musteriCepTel')?.setValue(value, { emitEvent: false });
  }

  toggleManuelGiris(index: number) {
    const cihaz = this.cihazlar.at(index);
    cihaz.patchValue({ manuelGiris: !cihaz.value.manuelGiris });
  }
}
